import React, { useMemo } from "react";
import RffFormChanges from "../components/finalForm/RffFormChanges";
import { useEndpointHook } from "../hooks/useEndpointHook";
import RffDocumentMetaData from "../components/finalForm/features/RffDocumentMetaData";
import { useDispatch } from "react-redux";
import { sidebarClose } from "../redux/reducers/sidebarReducer";

const UpdateBorrowerDocumentMetadataForm = ({ file }) => {
  const { loading, updateProfileDocuments } = useEndpointHook();
  const dispatch = useDispatch();
  const onSubmit = (changedValues, { form, values, changes }) => {
    const payload = [{ _id: file._id || file?.oid, ...changedValues }];
    updateProfileDocuments({
      files: payload,
      onSuccessFn: () => {
        dispatch(sidebarClose());
      },
    });
  };

  const initialValues = useMemo(() => {
    return {
      file_display_name: file?.file_display_name,
      docGroup: file?.docGroup,
      docType: file?.docType,
    };
  }, [file]);

  return (
    <RffFormChanges
      loading={loading}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <RffDocumentMetaData />
    </RffFormChanges>
  );
};

export default UpdateBorrowerDocumentMetadataForm;
